import { render, staticRenderFns } from "./QuestionBankCenter.vue?vue&type=template&id=38f0fc62&scoped=true&"
import script from "./QuestionBankCenter.vue?vue&type=script&lang=js&"
export * from "./QuestionBankCenter.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankCenter.vue?vue&type=style&index=0&id=38f0fc62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0fc62",
  null
  
)

export default component.exports